export default __webpack_public_path__ + "static/media/sandero-colour-7.61810ef8.jpg";